import {css} from 'styled-components';

type Size = 'small' | 'normal' | 'big' | 'huge' | 'fill' | 'default';

export const sizes: Record<Size, ReturnType<typeof css>> = {
  small: css`
    height: 1.125rem;
  `,
  normal: css`
    height: 1.5rem;
  `,
  big: css`
    height: 2.25rem;
  `,
  huge: css`
    height: 3rem;
  `,
  fill: css`
    height: 100%;
  `,
  default: css`
    height: var(--icon-default-size, calc(24 / 14 * 1em));
  `,
};
